import { validateSomething } from "../../Form/Validations";

export class Integrator {
    /**
   * @returns {import("../types").DialogState}
   */
    static actionDialogState(t, data) {
        const distribuidorId = data.otras_configuraciones?.distribuidor_id;
        return {
            visible: true,
            activeStep: 0,
            nombre_servicio: data.nombre_servicio,
            tipousuario_api_permitido: [5],
            data: {
                distribuidor_id: distribuidorId,
            },
            resolveBody: (values, props) => {
                return {
                    url: `/farms/${props.farmId}/integrador/${distribuidorId}/conectarIntegrador`,
                    body: {
                        tipousuario_id: values.tipousuario_id,
                    },
                    buy_seat: props.dialogState.data?.buy_seat === "seat"
                };
            },
            steps: [
                {
                    label: t("sass.conectar"),
                    inputs: [
                        {
                            label: t("sass.acceso"),
                            campo: "tipousuario_id",
                            options: [{ label: t("sass.tipoUsuario.5"), value: 5 }],
                            validation: validateSomething,
                            component: "select",
                        },
                    ],
                },
            ],
        };
    }
    /**
   * @returns {import("../types").DialogState}
   */
    static oldIntegratorDialog(t, data, i18n) {
        return {
            visible: true,
            activeStep: 0,
            nombre_servicio: data.nombre_servicio,
            data: {},
            skipCostStep: true,
            skipReviewStep: true,
            hideStepper: true,
            disableButtons: true,
            steps: [
                {
                    label: t("external.connection-information"),
                    inputs: [
                        {
                            component: "info",
                            content: () => {
                                return (
                                    <div className="mkt-old-integrator-info">
                                        <div className="title">{t("marketplace.contactSupport")}</div>
                                        <div className="description">
                                            {t("marketplace.oldIntegratorModal")}
                                        </div>
                                        <div className="email">
                                            <span className="mr-1">
                                                <svg
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M18.3333 5.00001C18.3333 4.08334 17.5833 3.33334 16.6666 3.33334H3.33329C2.41663 3.33334 1.66663 4.08334 1.66663 5.00001V15C1.66663 15.9167 2.41663 16.6667 3.33329 16.6667H16.6666C17.5833 16.6667 18.3333 15.9167 18.3333 15V5.00001ZM16.6666 5.00001L9.99996 9.16668L3.33329 5.00001H16.6666ZM16.6666 15H3.33329V6.66668L9.99996 10.8333L16.6666 6.66668V15Z"
                                                        fill="#1E84A6"
                                                    />
                                                </svg>
                                            </span>
                                            {i18n.language === "es"
                                                ? "soporte@wiseconn.com"
                                                : "support@wiseconn.com"}
                                        </div>
                                        <div className="phone">
                                            <span className="mr-1">
                                                <svg
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M5.51667 8.99167C6.71667 11.35 8.65 13.2833 11.0083 14.4833L12.8417 12.65C13.075 12.4167 13.4 12.35 13.6917 12.4417C14.625 12.75 15.625 12.9167 16.6667 12.9167C16.8877 12.9167 17.0996 13.0045 17.2559 13.1607C17.4122 13.317 17.5 13.529 17.5 13.75V16.6667C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5C12.9094 17.5 9.30609 16.0074 6.64932 13.3507C3.99256 10.6939 2.5 7.09057 2.5 3.33333C2.5 3.11232 2.5878 2.90036 2.74408 2.74408C2.90036 2.5878 3.11232 2.5 3.33333 2.5H6.25C6.47101 2.5 6.68298 2.5878 6.83926 2.74408C6.99554 2.90036 7.08333 3.11232 7.08333 3.33333C7.08333 4.375 7.25 5.375 7.55833 6.30833C7.65 6.6 7.58333 6.925 7.35 7.15833L5.51667 8.99167Z"
                                                        fill="#1E84A6"
                                                    />
                                                </svg>
                                            </span>
                                            {i18n.language === "es"
                                                ? "(+56 2) 26565003"
                                                : "+1 (559) 344-0800"}
                                        </div>
                                    </div>
                                );
                            },
                        },
                    ],
                },
            ],
        };
    }

    static resolveOldIntegratorAccessType(connection, t) {
        let actividad_final = 0;
        Array.isArray(connection.connection_data.actividad_id) && connection.connection_data.actividad_id.forEach(act => {
            if (act > actividad_final) { actividad_final = act; }
        });
        if (actividad_final) {
            return t(`sass.tipoPermiso.${actividad_final}`);
        }
        return "";
    }
}
